import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { conversationsAtom, frameParamsAtom } from 'src/app/state/atoms';
import { sendConversationClosedEvent } from 'src/app/lib/google-analytics';
import { getRuntimeEnvironment } from 'src/app/utils/getRuntimeEnvironment';

function useGaChatClosed() {
  const [frameParams] = useRecoilState(frameParamsAtom);
  const [conversations] = useRecoilState(conversationsAtom);

  useEffect(() => {
    const unloadCallback = () => {
      if (getRuntimeEnvironment() === 'prod')
        sendConversationClosedEvent(conversations, frameParams);
    };
    window.addEventListener('pagehide', unloadCallback);
    return () => {
      window.removeEventListener('pagehide', unloadCallback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversations.data.messages]);
}

export default useGaChatClosed;
